import React, { useId } from 'react';

type TooltipProps = {
  children: React.ReactNode;
  content: React.ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
};

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  content,
  placement = 'top',
  className = '',
}) => {
  const tid = useId();

  // 泡泡定位
  const bubblePos =
    placement === 'top'
      ? 'bottom-full mb-2 left-1/2 -translate-x-1/2'
      : placement === 'bottom'
        ? 'top-full mt-2 left-1/2 -translate-x-1/2'
        : placement === 'left'
          ? 'right-full mr-2 top-1/2 -translate-y-1/2'
          : 'left-full ml-2 top-1/2 -translate-y-1/2';

  // 箭頭定位（使用「負邊距」讓箭頭與泡泡**重疊貼合**）
  const arrowPos =
    placement === 'top'
      ? 'left-1/2 -translate-x-1/2 -bottom-1' // 這行改成負 bottom，貼住泡泡下緣
      : placement === 'bottom'
        ? 'left-1/2 -translate-x-1/2 -top-1'
        : placement === 'left'
          ? 'top-1/2 -translate-y-1/2 -right-1'
          : 'top-1/2 -translate-y-1/2 -left-1';

  // 箭頭陰影（可選）：讓銜接更自然
  const arrowShadow =
    'shadow-[0_0_0_1px_rgba(0,0,0,0.0)]'; // 需要可改成 0.1 之類

  return (
    <span className={`relative inline-flex items-center group ${className}`}>
      <span tabIndex={0} aria-describedby={tid} className="peer cursor-pointer outline-none">
        {children}
      </span>

      <span
        id={tid}
        role="tooltip"
        className={`
          pointer-events-none select-none
          absolute z-50
          bg-black text-white text-xs px-3 py-1.5 rounded-lg
          whitespace-nowrap
          opacity-0 invisible
          transition-opacity duration-150
          group-hover:opacity-100 group-hover:visible
          peer-focus-visible:opacity-100 peer-focus-visible:visible
          ${bubblePos}
        `}
      >
        {content}

        {/* 箭頭：用負邊距把菱形「塞進」泡泡，消除間隙 */}
        <span
          className={`
            absolute w-2.5 h-2.5 bg-black rotate-45 ${arrowPos} ${arrowShadow}
          `}
        />
      </span>
    </span>
  );
};
